import { HexColor } from 'terra-draw';
import { Action } from '@/OptimusRoutes/components/terraDraw/store/geofenceEditorActions';
import { ActionType } from '@/types/actionType';
import { DrawFeature } from '@/utilities/map.utils';

type State = {
	isPanelActive: boolean;
	selectedFeatures: DrawFeature[];
	previousSelectedFeatures: DrawFeature[];
	feature: DrawFeature | null;
	color: HexColor;
	isRedrawing: boolean;
};

const INITIAL_STATE: State = {
	isPanelActive: false,
	selectedFeatures: [],
	previousSelectedFeatures: [],
	feature: null,
	color: '#ed1b24' as HexColor,
	isRedrawing: false,
};

const GeofenceEditorReducer = (state: State = INITIAL_STATE, action: Action): State => {
	switch (action.type) {
		case ActionType.GEOFENCE_EDITOR_SET_IS_PANEL_ACTIVE:
			return {
				...state,
				isPanelActive: action.payload.isActive,
				isRedrawing: action.payload.isRedrawing ?? false,
			};

		case ActionType.GEOFENCE_EDITOR_SET_SELECTED_FEATURES:
			return {
				...state,
				selectedFeatures: action.payload,
			};

		case ActionType.GEOFENCE_EDITOR_SET_FEATURE:
			return {
				...state,
				feature: action.payload,
			};

		case ActionType.GEOFENCE_EDITOR_SET_COLOR:
			return {
				...state,
				color: action.payload,
			};

		case ActionType.GEOFENCE_EDITOR_UPDATE: {
			const updates = Object.fromEntries(
				Object.entries(action.payload).filter(([_, value]) => value !== undefined)
			);
			return { ...state, ...updates };
		}
		case ActionType.GEOFENCE_EDITOR_CLEAR:
			return {
				...state,
				feature: null,
			};

		case ActionType.GEOFENCE_EDITOR_RESET:
			return INITIAL_STATE;

		default:
			return state;
	}
};

export default GeofenceEditorReducer;
